<template>
	<div v-loading="loading" class="main_bg" element-loading-text="加载中...">
		<div class="item_info border_Warningcolor">
			<el-descriptions class="margin-top" title="充值记录详情" :column="3" border>
				<el-descriptions-item label="订单号">{{ editForm.code }}</el-descriptions-item>
				<el-descriptions-item label="所属门店">{{ editForm.storeName }}</el-descriptions-item>
				<el-descriptions-item label="会员卡编号">{{ editForm.vipNo }}</el-descriptions-item>
				<el-descriptions-item label="经办人">{{ editForm.creator }}</el-descriptions-item>
				<el-descriptions-item label="经办时间">{{ editForm.createTime }}</el-descriptions-item>
				<el-descriptions-item label="充值状态">{{ editForm.stateStr }}</el-descriptions-item>
				<el-descriptions-item label="是否确认">{{ editForm.isConfirm ? "是" : "否" }}</el-descriptions-item>
				<el-descriptions-item label="确认人">{{ editForm.confirmUserName }}</el-descriptions-item>
				<el-descriptions-item label="确认时间">{{ editForm.confirmTime }}</el-descriptions-item>
				<el-descriptions-item label="充值总额">{{ editForm.rechargeMoney }}</el-descriptions-item>
				<el-descriptions-item label="赠送金额">{{ editForm.bonusMoney }}</el-descriptions-item>
				<el-descriptions-item label="总支付金额">{{ editForm.totalPayMoney }}</el-descriptions-item>
				<el-descriptions-item label="欠款金额">{{ editForm.amountMoney }}</el-descriptions-item>
				<el-descriptions-item label="是否完成">{{ editForm.isConfirm ? "是" : "否" }}</el-descriptions-item>
				<el-descriptions-item label="完成时间">{{ editForm.finishedTime }}</el-descriptions-item>
				<el-descriptions-item label="是否有电话提成">{{ editForm.isPhoneBonus ? "是" : "否" }}</el-descriptions-item>
				<el-descriptions-item label="电话提成员工" v-if="editForm.isPhoneBonus">{{ editForm.phoneBonusUserName }}</el-descriptions-item>
				<!-- <el-descriptions-item span="3">
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            备注
                        </template>
                        {{ editForm.remark }}
                    </el-descriptions-item> -->
			</el-descriptions>
		</div>
		<div class="item_info">
			<el-descriptions class="margin-top" title="顾客信息" :column="6" border>
				<el-descriptions-item label="顾客姓名">{{ transformEmpty(customerInfo.name) }}</el-descriptions-item>
				<el-descriptions-item label="性别">{{ transformGender(customerInfo.gender) }}</el-descriptions-item>
				<el-descriptions-item label="年龄">{{ transformEmpty(customerInfo.age) }}</el-descriptions-item>
				<el-descriptions-item label="顾客电话">{{ transformEmpty(customerInfo.phone) }}</el-descriptions-item>
				<el-descriptions-item label="所属门店" span="3">{{ transformEmpty(customerInfo.belongStoreName) }}</el-descriptions-item>
				<el-descriptions-item label="(右眼)球镜">{{ transformEmpty(customerInfo.rParams.qiuJing) }}</el-descriptions-item>
				<el-descriptions-item label="柱镜">{{ transformEmpty(customerInfo.rParams.zhuJing) }}</el-descriptions-item>
				<el-descriptions-item label="轴位">{{ transformEmpty(customerInfo.rParams.zhouWei) }}</el-descriptions-item>
				<el-descriptions-item label="瞳高">{{ transformEmpty(customerInfo.rParams.tongGao) }}</el-descriptions-item>
				<el-descriptions-item label="瞳距">{{ transformEmpty(customerInfo.rParams.tongJu) }}</el-descriptions-item>
				<el-descriptions-item label="矫正视力">{{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}</el-descriptions-item>
				<el-descriptions-item label="(左眼)球镜">{{ transformEmpty(customerInfo.lParams.qiuJing) }}</el-descriptions-item>
				<el-descriptions-item label="柱镜">{{ transformEmpty(customerInfo.lParams.zhuJing) }}</el-descriptions-item>
				<el-descriptions-item label="轴位">{{ transformEmpty(customerInfo.lParams.zhouWei) }}</el-descriptions-item>
				<el-descriptions-item label="瞳高">{{ transformEmpty(customerInfo.lParams.tongGao) }}</el-descriptions-item>
				<el-descriptions-item label="瞳距">{{ transformEmpty(customerInfo.lParams.tongJu) }}</el-descriptions-item>
				<el-descriptions-item label="矫正视力">{{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info border_Danger">
			<div class="item_title">
				<div class="title">支付记录</div>
				<div class="btnDiv">
					<div class="btnDivItem">会员类型：{{ customerInfo.customerTypeStr }}</div>
					|
					<div class="btnDivItem">档案编号：{{ customerInfo.customerNo }}</div>
				</div>
			</div>
			<payRecord ref="payRecord"></payRecord>
		</div>
		<div class="item_info border_Danger">
			<div class="item_title">
				<div class="title">提成记录</div>
				<div class="btnDiv"></div>
			</div>
			<commissionRecord ref="commissionRecord"></commissionRecord>
		</div>
	</div>
</template>
<script>
import { GetVipRechargeHistoryDetail } from "@/api/vipApi.js";
import { getCustomerInfoDetail } from "@/api/baseDataApi.js";
import payRecord from "@/views/pay/record.vue";
import commissionRecord from "@/views/accounting/storeCost/commission/record.vue";
export default {
	props: [],
	data() {
		return {
			loading: false,
			editForm: {},
			customerInfo: {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: "",
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				},
				rParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: "",
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				}
			}
		};
	},
	components: {
		payRecord,
		commissionRecord
	},
	created() {},
	methods: {
		// 显示
		getDetail(row) {
			this.resetData();
			this.loading = true;
			GetVipRechargeHistoryDetail({
				keyId: row.keyId
			})
				.then((res) => {
					if (res.code == 1) {
						getCustomerInfoDetail({ keyId: res.data.customerKeyId }).then((res) => {
							if (res.code == 1) {
								this.customerInfo = this.normalizeCustomerInfo(res.data);
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						});
						this.editForm = res.data;
						this.$refs.payRecord.showPayReord(row.keyId);
						this.$refs.commissionRecord.showCommissionReord(row.keyId);
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.editForm = {};
			this.customerInfo = this.buildEmptyCustomerInfo();
		},
		// 构造空的顾客信息（含 lParams/rParams 默认对象，避免模板访问 null 报错）
		buildEmptyCustomerInfo() {
			return {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" },
				rParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" }
			};
		},
		// 归一化后端返回的顾客信息：lParams/rParams 可能为 null，需回填默认对象
		normalizeCustomerInfo(data) {
			const empty = this.buildEmptyCustomerInfo();
			const info = Object.assign({}, empty, data || {});
			info.lParams = Object.assign({}, empty.lParams, (data && data.lParams) || {});
			info.rParams = Object.assign({}, empty.rParams, (data && data.rParams) || {});
			return info;
		},
		// 显示提成记录
		getCommissionDetail(row) {
			GetVipRechargeHistoryDetail({
				keyId: row.businessKeyId
			}).then((res) => {
				if (res.code == 1) {
					getCustomerInfoDetail({ keyId: res.data.customerKeyId }).then((res) => {
						if (res.code == 1) {
							this.customerInfo = this.normalizeCustomerInfo(res.data);
						} else {
							this.$message({
								type: "error",
								message: res.msg
							});
						}
					});
					this.editForm = res.data;
					this.$refs.payRecord.showPayReord(row.businessKeyId);
					this.$refs.commissionRecord.showCommissionReord(row.businessKeyId, row.keyId);
				} else {
					this.$message({
						type: "error",
						message: res.msg
					});
				}
			});
		},
		//转换性别
		transformGender(gender) {
			if (gender == 1) {
				return "男";
			} else if (gender == 0) {
				return "女";
			} else {
				return "--";
			}
		},
		//判断为空则用 -- 替代
		transformEmpty(obj) {
			if (obj == "" || obj == null || obj == undefined) {
				obj = "--";
			}
			return obj;
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid #55aaff;
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
	border-left: 5px solid #ff9900;
}

.border_Green {
	border-left: 5px solid #00cc66;
}

.border_Danger {
	border-left: 5px solid #ff0000;
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}

	.btnDivItem {
		display: inline-block;
	}

	.text-red {
		display: block;
		background-color: #ff0000;
	}
}
</style>
